import { createContext, useContext } from 'react';
import { PopoverManagerState } from '../';

export const PopoverManagerContext = createContext<PopoverManagerState>({
  activePopovers: new Map(),
  openPopover: () => 0,
  closePopover: () => {},
});

export function usePopoverManager() {
  const context = useContext(PopoverManagerContext);
  if (!context) {
    throw new Error(`usePopoverManager must be used within a PopoverManagerProvider`);
  }
  return context;
}
